EditCategoriasCtrl.$inject = ['$log', '$http', 'CategoriasLocal', '$q', 'CategoriaActionsService'];
export default function EditCategoriasCtrl($log, $http, CategoriasLocal, $q, CategoriaActionsService) {
    var vm = this;

    vm.loading = {
        datos: true
    };
    cargarCategorias();

    vm.seleccionarCategoria = function (categoria) {
        var url = Sigo.var.path + '/api/v1/tareasperiodicas/' + vm.tareaPeriodicaId + '/categorias';
        var promesa = null;
        vm.categorias.some(function (item, index) {
            if (item.id == categoria.id) {
                var seleccionar = (typeof vm.categorias[index].seleccionada == 'undefined' || vm.categorias[index].seleccionada == false);
                vm.categorias[index].seleccionada = seleccionar;
                if (seleccionar) {
                    var data = {categoria_id: categoria.id};
                    promesa = $http.post(url, data);
                } else {
                    url += '/' + categoria.id;
                    promesa = $http.delete(url);
                }
            }
        });
        if (promesa != null)
            promesa.then(function (data) {
                vm.callback();
            });
    };

    function cargarCategorias() {
        vm.loading.datos = true;
        obtenerCategorias().then(function () {
            vm.loading.datos = false;
            return seleccionarVarias(vm.categoriasIds.split(','));
        }).then(function () {
            console.log('Categorias cargadas..');
            vm.loading.datos = false;
        });
    }

    function obtenerCategorias() {
        var promesa = CategoriasLocal.get();
        promesa.then(function (data) {
            vm.categorias = data;
        });
        return promesa;
    }

    vm.nuevaCategoria = function () {
        console.log('Creando nueva categoría..');
        CategoriaActionsService.crearCategoria().then(function (respuesta) {
            vm.categorias.unshift(respuesta.data);
            vm.seleccionarCategoria(respuesta.data);
        });
    };

    function obtenerCategoriasPeriodica(tareaPeriodicaId) {
        var url = Sigo.var.path + '/api/v1/tareasperiodicas/' + tareaPeriodicaId + '/categorias';
        var promesa = $http.get(url);
        promesa.then(function (data) {
            // seleccionarVarias(data.data);
        });
        return promesa;
    }

    function seleccionarVarias(categoriasIds) {
        var defered = $q.defer();
        var promesa = defered.promise;

        categoriasIds.forEach(function (categoriaId) {
            vm.categorias.some(function (item, index) {
                if (item.id == categoriaId) {
                    vm.categorias[index].seleccionada = true
                }
            });
        });
        defered.resolve();
        return promesa
    }
}